import { SVG, SVGProps } from './svg'

export function IconTrashCan(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 12 14">
      <path
        fillRule="evenodd"
        d="M11.3 2.7V2c0-.2-.1-.3-.3-.3H8V1c0-.4-.3-.7-.7-.7H4.7C4.3.3 4 .6 4 1v.7H1c-.2 0-.3.1-.3.3v.7c0 .2.1.3.3.3h10c.2 0 .3-.1.3-.3Zm-8 11c-.8 0-1.3-.6-1.4-1.3l-.6-8h9.4l-.6 8c0 .7-.6 1.3-1.3 1.3H3.2Z"
      />
    </SVG>
  )
}
